import header from './layouts/v1/header';
import footer from './layouts/v1/footer';

header();
footer();
